/**
 * Snackbar Slice
 * Manages snackbar notifications
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  variant: 'info', // 'success' | 'error' | 'warning' | 'info'
  message: '',
  duration: 4000,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.show = true;
      state.variant = action.payload.variant || 'info';
      state.message = action.payload.message || '';
      state.duration = action.payload.duration || 4000;
    },
    hideSnackbar: (state) => {
      state.show = false;
      state.variant = 'info';
      state.message = '';
      state.duration = 4000;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

// Action creators for convenience
export const showSuccess = (message, duration = 4000) =>
  showSnackbar({ variant: 'success', message, duration });

export const showError = (message, duration = 4000) =>
  showSnackbar({ variant: 'error', message, duration });

export const showWarning = (message, duration = 4000) =>
  showSnackbar({ variant: 'warning', message, duration });

export const showInfo = (message, duration = 4000) =>
  showSnackbar({ variant: 'info', message, duration });

export default snackbarSlice.reducer;


